<div class="badge size-{{ size }} color-{{ color }}" [ngStyle]="style">
	<div class="badge-number text-bold">
		<div *ngIf="!isLoading; else loading">
			{{ number }}
		</div>
	</div>
	<div class="badge-label" [dcrHTMLKey]="subtitle.dcrKey">
		{{ subtitle.dcrValue }}
	</div>
	<ng-template #loading>
		<ngx-skeleton-loader [theme]="{ width: '25px', height: '16px', 'border-radius': '0', margin: '0' }"></ngx-skeleton-loader>
	</ng-template>
</div>
